import { Event } from 'betweb-openapi-axios'

export const getFullEventComment = (comments: Event['comments']) =>
  comments?.join(', ') ?? ''
